import { DYNAMIC_TRANSLATIONS_CONFIG, getMarketCachedValue, setMarketCachedValue } from '../utils';
import { MarketTranslationStrategy } from './types';
import { getCurrentLanguage, matchesKey, shouldLocalize } from './utils';

export const translateOMMarket: MarketTranslationStrategy = (marketName, marketType, t) => {
  if (!shouldLocalize()) {
    return marketName;
  }

  const directTranslationKey = marketName.toLowerCase();

  const language = getCurrentLanguage();
  const cachedTranslation = getMarketCachedValue(language, directTranslationKey);
  if (cachedTranslation) {
    return cachedTranslation;
  }

  const directTranslation = t(directTranslationKey, {
    ns: 'markets',
    defaultValue: null,
  });

  if (directTranslation) {
    const language = getCurrentLanguage();
    setMarketCachedValue(language, directTranslationKey, directTranslation);
    return directTranslation;
  }

  for (const [key, value] of Object.entries(DYNAMIC_TRANSLATIONS_CONFIG)) {
    if (matchesKey(marketType, key) || matchesKey(marketName, key)) {
      const { patterns, params } = value;
      const rule = patterns.find(({ pattern }: { pattern: RegExp }) => pattern.test(marketName));

      if (rule) {
        const match = rule.pattern.exec(marketName);
        if (!match) continue;

        const additionalParams =
          match.length > 2 || key !== 'Interval'
            ? params.reduce((acc: { [key: string]: string }, param, index) => {
                acc[param] = match[index + 1];
                return acc;
              }, {})
            : { [params[1]]: match[1] };

        const translation = t(rule.key, marketName, { ns: 'markets', ...additionalParams });
        const language = getCurrentLanguage();
        setMarketCachedValue(language, marketName, translation);
        return translation;
      }
    }
  }

  return marketName;
};
